import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import Rail from "web/react/components/rail/rail";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import analytics from "web/script/analytics/analytics";
import styles from "./related-searches-rail.css";
import AjaxRelatedSearchProductImages from "./ajax-related-search-product-images";

function RelatedSearchesRail({ title, relatedSearches, showImages, inlineImages, features }) {
    let breadCrumbCount = 0;

    let intersectionObserverOptions = {
        threshold: 0,
        rootMargin: "0px",
        once: true,
    };
    const railRef = useRef();
    const [isVisible] = useIntersectionObserver(intersectionObserverOptions, railRef);

    function handleClick() {
        analytics.event("pdp_related_searches", "pdp_related_click", "related_search_clicked");
    }

    return (
        <Rail
            title={title}
            analyticsLabel="related_searches"
            className={styles.railWrapper}
            itemScope=""
            itemType="http://schema.org/BreadcrumbList"
            peekingCard={features.uj_peeking_card}
        >
            <div ref={railRef} className={styles.railInner}>
                {relatedSearches.map((relatedSearch) => {
                    if (relatedSearch.is_breadcrumb) {
                        breadCrumbCount++;
                    }
                    return (
                        <div
                            className={styles.cardWrapper}
                            key={relatedSearch.url}
                            itemProp={relatedSearch.is_breadcrumb ? "itemListElement" : undefined}
                            itemScope={relatedSearch.is_breadcrumb ? "" : undefined}
                            itemType={
                                relatedSearch.is_breadcrumb
                                    ? "http://schema.org/ListItem"
                                    : undefined
                            }
                        >
                            <div
                                className={classnames(styles.relatedSearchCard, {
                                    [styles.relatedSearchCardInline]: inlineImages,
                                })}
                            >
                                {showImages && isVisible && (
                                    <a
                                        href={relatedSearch.url}
                                        itemProp={relatedSearch.is_breadcrumb ? "item" : undefined}
                                        onClick={handleClick}
                                    >
                                        <AjaxRelatedSearchProductImages
                                            feedUrl={relatedSearch.url}
                                            isRoundedImage={inlineImages === true}
                                            showFallBack={inlineImages === true}
                                        />
                                    </a>
                                )}
                                <a
                                    href={relatedSearch.url}
                                    className={styles.relatedSearchTerm}
                                    itemProp={relatedSearch.is_breadcrumb ? "item" : undefined}
                                >
                                    {relatedSearch.text}
                                </a>
                            </div>
                            {relatedSearch.is_breadcrumb && (
                                <meta itemProp="position" content={breadCrumbCount} />
                            )}
                        </div>
                    );
                })}
            </div>
        </Rail>
    );
}

RelatedSearchesRail.defaultProps = {
    showImages: true,
    inlineImages: false,
};

RelatedSearchesRail.propTypes = {
    title: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.string),
    relatedSearches: PropTypes.array.isRequired,
    showImages: PropTypes.bool,
    inlineImages: PropTypes.bool,
};

export default RelatedSearchesRail;
